import { render, staticRenderFns } from "./WorkspaceSideRail.vue?vue&type=template&id=044afb21&scoped=true&"
import script from "./WorkspaceSideRail.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSideRail.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSideRail.vue?vue&type=style&index=0&id=044afb21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044afb21",
  null
  
)

export default component.exports